import { render, staticRenderFns } from "./SearchSpecialty.vue?vue&type=template&id=b8261822&scoped=true"
import script from "./SearchSpecialty.vue?vue&type=script&lang=js"
export * from "./SearchSpecialty.vue?vue&type=script&lang=js"
import style0 from "./SearchSpecialty.vue?vue&type=style&index=0&id=b8261822&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8261822",
  null
  
)

export default component.exports